import { VendorPerformanceDistinctFsc } from '../models/vendor-performance/vendor-performance-distinct-fsc.model';
import { VendorPerformanceTimeline } from '../models/vendor-performance/vendor-performance-timeline.model';
import { VendorPerformanceRepairType } from '../models/vendor-performance/vendor-performance-repair-type.model';
import { VendorPerformanceCpn } from '../models/vendor-performance/vendor-performance-cpn.model';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from "../../../config/api.configuration";
import {HttpClient} from "@angular/common/http";
import {Burly} from "kb-burly";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TorchVendorPerformanceService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getVendorPerformanceCpn(partNumber: string,
                                 filter?: string | string[]): Observable<VendorPerformanceCpn[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/vend-perf-cpn')
    .addSegment('/by-cpn/' + partNumber);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<VendorPerformanceCpn[]>(finalURL);
  }

  public getVendorPerformanceRepairType(partNumber: string,
                                        filter?: string | string[]): Observable<VendorPerformanceRepairType[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/vend-perf-repair-type')
    .addSegment('/by-cpn/' + partNumber);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<VendorPerformanceRepairType[]>(finalURL);
  }

  public getVendorPerformanceRepairTypeByFsc(partNumber: string,
                                             fsc: string,
                                             filter?: string | string[]): Observable<VendorPerformanceRepairType[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/vend-perf-repair-type')
    .addSegment('/by-cpn-fsc/' + partNumber)
    .addSegment('/' + fsc);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<VendorPerformanceRepairType[]>(finalURL);
  }

  public getRepairTypeFscByCpn(companyPartNumber) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/vend-perf-repair-type')
      .addSegment('/distinct/' + companyPartNumber)
      .get;

    return this.httpClient.get<VendorPerformanceDistinctFsc[]>(endpoint)
  }

  public getVendorPerformanceTimeline(partNumber: string,
                                      filter?: string | string[]): Observable<VendorPerformanceTimeline[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/vend-perf-timeline')
    .addSegment('/by-cpn/' + partNumber);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<VendorPerformanceTimeline[]>(finalURL);
  }

  public getVendorPerformanceTimelineByFsc(partNumber: string,
                                           fsc: string,
                                           filter?: string | string[]): Observable<VendorPerformanceTimeline[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/vend-perf-timeline')
    .addSegment('/by-cpn-fsc/' + partNumber)
    .addSegment('/' + fsc);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<VendorPerformanceTimeline[]>(finalURL);
  }

  public getTimelineFscByCpn(companyPartNumber) {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/vend-perf-timeline')
      .addSegment('/distinct/' + companyPartNumber)
      .get;

    return this.httpClient.get<VendorPerformanceDistinctFsc[]>(endpoint)
  }
}
